export default class Auth {
  constructor(api) {
    this.api = api;
  }

  getModulesStates(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/modules")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  editModulesStates(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/modules", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/modules.js